module.exports = __webpack_public_path__ + "static/media/banner.589501f5.jpeg";